export default {"src":"/_next/static/media/ico-share.824b26e7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};